import { TextAlignLeft } from "@phosphor-icons/react";

import RenderIf from "common/components/RenderIf";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "common/components/ui/Accordion";
import { Tag } from "common/components/ui/Tag";
import { typedObjectEntries } from "common/helpers/utils";

import { PROFILE_SEARCH_OPTIONS } from "../../../../../../../constants";
import { useSearchParamsContext } from "../../SearchParamsContext";
import Keywords from "../Keywords";
import SearchParamSelect from "./SearchParamSelect";

export default function MobileLayout() {
  const { searchParams } = useSearchParamsContext();

  return (
    <Accordion type="multiple" className="w-full" defaultValue={["keywords"]}>
      <AccordionItem value="keywords" className="border-b border-b-black-200">
        <AccordionTrigger className="h-10 gap-x-1.5 text-button-sm">
          <TextAlignLeft size={20} />
          Keywords
          <RenderIf condition={!!searchParams.keywords.length}>
            <Tag>{searchParams.keywords.length}</Tag>
          </RenderIf>
        </AccordionTrigger>
        <AccordionContent>
          <Keywords />
        </AccordionContent>
      </AccordionItem>
      {typedObjectEntries(PROFILE_SEARCH_OPTIONS).map(([key]) => (
        <SearchParamSelect key={key} optionsKey={key} />
      ))}
    </Accordion>
  );
}
